// src/pages/HomePage.js
import React from 'react';
import './HomePage.css';
import Header from '../components/Header';
import Banner from '../components/Banner';
import Footer from '../components/Footer';

const HomePage = () => {
  return (
    <div className="homepage-container">
      <Header />
      <Banner />
      <div className="map-container">
        <div className="map-image-container">
          <img src="/images/map.jpg" alt="Teeth Whitening" className="map-image" />
        </div>
        <div className="map-description">
          <h2 className="map-header">Directions</h2>
          <ul>
            <li><strong>GA 400-N:</strong>  Take the NORTHRIDGE ROAD exit, EXIT 6. Take the ramp toward GA-9/DUNWOODY PL. Turn SLIGHT RIGHT onto NORTHRIDGE RD. and continue approx. 0.5 miles. Turn RIGHT onto ROSWELL RD/GA-9 and continue approx 0.1 miles. 8329 ROSWELL RD is on the RIGHT in the Northridge Shopping Center.</li>
            <li><strong>GA 400-S:</strong>  Take NORTHRIDGE ROAD exit, EXIT 6. Turn left on NORTHRIDGE ROAD and continue 0.4 miles. Turn RIGHT on ROSWELL ROAD NE/GA-9 and go approx 0.1 miles. 8329 ROSWELL RD is on the RIGHT in the Northridge Shopping Center.</li>
            <li><strong>I-285-E:</strong> Take GA-400 N/US-19 N via EXIT 27 toward CUMMING / DAHLONEGA. Take the NORTHRIDGE ROAD exit, EXIT 6. Take the ramp toward GA-9/DUNWOODY PL. Turn SLIGHT RIGHT onto NORTHRIDGE RD. and continue approx. 0.5 miles. Turn RIGHT onto ROSWELL RD/GA-9 and continue approx 0.1 miles. 8329 ROSWELL RD is on the RIGHT in the Northridge Shopping Center.</li>
            <li><strong>I-285-W:</strong> Take GA-400 N/US-19 N via EXIT 27 toward CUMMING / DAHLONEGA. Take the NORTHRIDGE ROAD exit, EXIT 6. Take the ramp toward GA-9/DUNWOODY PL. Turn SLIGHT RIGHT onto NORTHRIDGE RD. and continue approx. 0.5 miles. Turn RIGHT onto ROSWELL RD/GA-9 and continue approx 0.1 miles. 8329 ROSWELL RD is on the RIGHT in the Northridge Shopping Center.</li>
          </ul>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default HomePage;

/*
<img
  src="https://images.unsplash.com/photo-1604328698692-f76ea9498e76?q=80&w=2670&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D"
  alt="Dental Office"
  className="office-image"
/>
*/